module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userInfoShow),
      expression: "userInfoShow"
    }],
    staticClass: "edituserinfo"
  }, [(_vm.userInfoShow) ? _c('div', {
    staticClass: "edit_mask",
    on: {
      "click": _vm.editMaskClick
    }
  }, [_c('div', {
    staticClass: "userInfo",
    class: _vm.userInfoHeight,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.contentClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.maskClick($event)
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), (_vm.title == '编辑资料') ? _c('div', {
    staticClass: "content"
  }, [(_vm.awater != null && _vm.awater.length == 0) ? _c('div', {
    staticClass: "awater",
    on: {
      "click": _vm.handleUpload
    }
  }) : _vm._e(), _vm._v(" "), (_vm.awater == null) ? _c('img', {
    staticClass: "awater-icon",
    attrs: {
      "src": require("./avatar.png")
    },
    on: {
      "click": _vm.handleUpload
    }
  }) : _vm._e(), _vm._v(" "), (_vm.awater != null && _vm.awater.length > 0) ? _c('img', {
    staticClass: "awater-icon",
    attrs: {
      "src": _vm.awater
    },
    on: {
      "click": _vm.handleUpload
    }
  }) : _vm._e(), _vm._v(" "), _c('my-upload', {
    attrs: {
      "field": "img",
      "width": 300,
      "height": 300,
      "withCredentials": _vm.withCredentials,
      "img-format": "png"
    },
    on: {
      "crop-success": _vm.cropSuccess
    },
    model: {
      value: (_vm.upload_show),
      callback: function($$v) {
        _vm.upload_show = $$v
      },
      expression: "upload_show"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle"
  }, [_c('div', {
    staticClass: "name_"
  }, [_vm._v("昵称     "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user_nickName),
      expression: "user_nickName"
    }],
    staticClass: "user_name",
    domProps: {
      "value": (_vm.user_nickName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user_nickName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sex_"
  }, [_vm._v("性别     \n                      "), _c('el-radio-group', {
    on: {
      "change": _vm.handleChangeOption
    },
    model: {
      value: (_vm.sex),
      callback: function($$v) {
        _vm.sex = $$v
      },
      expression: "sex"
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("男")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("女")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "birthday_",
    staticStyle: {
      "line-height": "25px"
    }
  }, [_vm._v("生日     \n                      "), _c('el-date-picker', {
    staticClass: "date_picker",
    attrs: {
      "type": "date",
      "size": "mini",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptions,
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.birthday),
      callback: function($$v) {
        _vm.birthday = $$v
      },
      expression: "birthday"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "personal_text"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("个性签名  ")]), _vm._v(" "), _c('el-input', {
    staticClass: "text",
    attrs: {
      "size": "mini",
      "type": "textarea",
      "rows": 3,
      "suffix-icon": "",
      "resize": "none"
    },
    model: {
      value: (_vm.intro),
      callback: function($$v) {
        _vm.intro = $$v
      },
      expression: "intro"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "cancel",
    attrs: {
      "type": "info",
      "size": "mini"
    },
    on: {
      "click": _vm.maskClick
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "confirm",
    attrs: {
      "type": "warning",
      "size": "mini"
    },
    on: {
      "click": _vm.handleUserInfoUpdate
    }
  }, [_vm._v("确定")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.title == '修改密码') ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "middle",
    staticStyle: {
      "top": "24px",
      "width": "260px",
      "height": "150px",
      "background": "#fff",
      "left": "60px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "30px",
      "background": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "line-height": "30px"
    }
  }, [_vm._v("旧密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }],
    staticStyle: {
      "margin-left": "10px",
      "border": "0px",
      "border-bottom": "1px solid #c7c7c7",
      "height": "30px",
      "width": "180px"
    },
    attrs: {
      "placeholder": "请输入你的原密码",
      "type": "password"
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px",
      "background": "#fff",
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "line-height": "30px"
    }
  }, [_vm._v("新密码")]), _vm._v(" "), ((_vm.password_type_new) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticStyle: {
      "margin-left": "10px",
      "border": "0px",
      "border-bottom": "1px solid #c7c7c7",
      "height": "30px",
      "width": "180px"
    },
    attrs: {
      "placeholder": "请输入你的新密码(至少六位)",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newPassword) ? _vm._i(_vm.newPassword, null) > -1 : (_vm.newPassword)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newPassword,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newPassword = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newPassword = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.newPassword = $$c
        }
      }
    }
  }) : ((_vm.password_type_new) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticStyle: {
      "margin-left": "10px",
      "border": "0px",
      "border-bottom": "1px solid #c7c7c7",
      "height": "30px",
      "width": "180px"
    },
    attrs: {
      "placeholder": "请输入你的新密码(至少六位)",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.newPassword, null)
    },
    on: {
      "change": function($event) {
        _vm.newPassword = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticStyle: {
      "margin-left": "10px",
      "border": "0px",
      "border-bottom": "1px solid #c7c7c7",
      "height": "30px",
      "width": "180px"
    },
    attrs: {
      "placeholder": "请输入你的新密码(至少六位)",
      "type": _vm.password_type_new
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "display": "inline-block",
      "top": "5px",
      "height": "14px",
      "left": "-20px"
    },
    on: {
      "click": function($event) {
        return _vm.showPassword('new')
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show_password_new),
      expression: "!show_password_new"
    }],
    attrs: {
      "src": require("./register_nosee.png")
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_password_new),
      expression: "show_password_new"
    }],
    attrs: {
      "src": require("./register_see.png")
    }
  })])]), _vm._v(" "), _c('el-button', {
    staticClass: "cancel",
    staticStyle: {
      "position": "absolute",
      "left": "40px",
      "bottom": "0"
    },
    attrs: {
      "type": "info",
      "size": "mini"
    },
    on: {
      "click": _vm.maskClick
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "confirm",
    staticStyle: {
      "position": "absolute",
      "left": "140px",
      "bottom": "0"
    },
    attrs: {
      "type": "warning",
      "size": "mini"
    },
    on: {
      "click": _vm.handleChangePassword
    }
  }, [_vm._v("确定")])], 1)]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0369cdfd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditUserInfo/EditUserInfo.vue
// module id = 378
// module chunks = 0